import { BsArrowLeft } from "react-icons/bs";
import { RiArrowRightSLine } from "react-icons/ri";
import img1 from '../../../Assets/case_2.png'
import img2 from '../../../Assets/case_2_1.png'
import img3 from '../../../Assets/case_2_2.png'
import avatar from '../../../Assets/avatar_teste.png'
import * as S from './styles';

export const SurfCenter = () => {
  return (
    <S.Wrapper>

      <S.HeaderBar>
        <S.BackButton
          onClick={() => window.history.back()} aria-label="Voltar"
        >
          <BsArrowLeft size={40} />
        </S.BackButton>
        <h2>Surf Center</h2>
      </S.HeaderBar>

      <S.Grid>
        <S.Sidebar>
          <S.SideBlock>

            <S.SideTitle>
              Overview
            </S.SideTitle>

            <p>
              O Surf Center é o primeiro clube do Brasil com piscina de ondas indoor e aquecida — um espaço que combina tecnologia, inovação e esporte.
            </p>

            <p>
              O grande desafio era garantir que cada cliente tivesse uma experiência personalizada, com ondas criadas sob medida e sem falhas no sistema.
            </p>

            <p>
              Com a solução desenvolvida pela Bindflow, foi implementado um sistema inteligente de controle automatizado das ondas, garantindo precisão, estabilidade e personalização completa da experiência.
            </p>

          </S.SideBlock>

          <S.SideBlock>
            <S.SideTitle>Entregáveis</S.SideTitle>
            <ul>
              <li><p>Desenvolvimento do sistema de controle inteligente das ondas.</p></li>
              <li><p>Integração com sensores e infraestrutura física existente.</p></li>
              <li><p>Interface de gestão e monitoramento em tempo real.</p></li>
              <li><p>Aumento da eficiência operacional e da satisfação dos clientes.</p></li>
              <li><p>Fortalecimento do posicionamento da marca como referência em inovação+.</p></li>
            </ul>
          </S.SideBlock>
        </S.Sidebar>

        <S.Main>
          <S.Img src={img1} alt="Hero" />

          <S.TwoCol>
            <S.Img src={img2} alt="" />
            <S.Img src={img3} alt="" />
          </S.TwoCol>

        </S.Main>
      </S.Grid>
    </S.Wrapper >
  );
};
